import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { LayoutFeed, RatioOptions } from '../../enums';
import { PgItemType } from './convertMediasToPG';
import { WidgetPropsI } from '../../types';

export const DEFAULT_BASE_WIDTH_GRID = 488;
export const DEFAULT_BASE_WIDTH_SLIDER = 218;

/**
 * Get dimensions based on layout type and user settings
 * Calculate dimensions based on baseWidth by layout and ratioSelected
 */
export const getDimensionsForLayout = (
  layoutSelected: number = LayoutFeed.Slider,
  ratioSelected: number = RatioOptions.option3,
  itemWidth?: number,
  itemHeight?: number,
): { width: number; height: number } => {
  // Get baseWidth based on layout type
  const getBaseWidth = (layout: number): number => {
    switch (layout) {
      case LayoutFeed.Grid:
        return DEFAULT_BASE_WIDTH_GRID;
      default:
        return DEFAULT_BASE_WIDTH_SLIDER;
    }
  };
  // If both itemWidth and itemHeight are provided, use them directly
  if (itemWidth && itemHeight) {
    return { width: itemWidth, height: itemHeight };
  }

  const baseWidth = getBaseWidth(layoutSelected);

  // Calculate dimensions using baseWidth and ratioSelected
  if (ratioSelected && ratioSelected > 0) {
    if (ratioSelected >= 1.0) {
      const height = baseWidth;
      const width = Math.round(height * ratioSelected);
      return { width, height };
    } else {
      const width = baseWidth;
      const height = Math.round(width / ratioSelected);
      return { width, height };
    }
  }

  return {
    width: itemWidth || baseWidth,
    height: itemHeight || baseWidth,
  };
};

/**
 * Add dimensions to media items based on layout and ratio settings
 */
export const addDimensionsToMedia = (
  igMedia: PgItemType[],
  props: WidgetPropsI,
  flowAPI?: PlatformControllerFlowAPI,
): PgItemType[] => {
  if (!flowAPI?.environment) {
    return igMedia;
  }

  const isMobile = flowAPI.environment.isMobile;
  const layoutSelected = Number(
    isMobile ? props.layoutSelected_m : props.layoutSelected,
  );
  const ratioSelected = Number(
    isMobile ? props.ratioSelected_m : props.ratioSelected,
  );

  return igMedia.map((item) => {
    const dimensions = getDimensionsForLayout(
      layoutSelected,
      ratioSelected,
      item?.width,
      item?.height,
    );

    return {
      ...item,
      width: dimensions.width,
      height: dimensions.height,
    };
  });
};
